import React, { useContext, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import axios from 'axios'

import Header from 'components/Header'
import Loading from 'components/Loading'
import Layout from 'layouts/Layout'
import NativeAuthContext from 'components/NativeAuth'

const Callout = React.lazy(() => import('vuse-callout'))

export default () => {
  const { user, setLoginModalVisibility, submitCalloutApplication, province, submitCalloutVotes } = useContext(
    NativeAuthContext
  )
  const [calloutVoteOptions, setCalloutVoteOptions] = useState([])

  useEffect(() => {
    let mounted = true

    async function main() {
      if (!mounted) return
      const { data } = await axios.get(`${process.env.GATSBY_AUTH_API}/callout_vote_options`)
      setCalloutVoteOptions(data.calloutVoteOptions)
    }

    main()

    return () => {
      mounted = false
    }
  }, [])

  const submitApplication = values => submitCalloutApplication(values)
  const submitVotes = options => submitCalloutVotes({ callout_vote_options: options })

  const isSSR = typeof window === 'undefined'

  return (
    <Layout hideHeader>
      <Header transparent />
      <Helmet>
        <body className="callout" />
      </Helmet>
      {!isSSR && (
        <React.Suspense fallback={<Loading />}>
          <Callout
            user={user}
            calloutVoteOptions={calloutVoteOptions}
            showLoginModal={() => setLoginModalVisibility(true)}
            submitApplication={submitApplication}
            province={province}
            submitVotes={submitVotes}
          />
        </React.Suspense>
      )}
    </Layout>
  )
}
